import { IFullPermission } from '@/shared/types/permission';
import { IUserInfo } from '@/shared/types/userInfo';
import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isLogin: true,
    userInfo: {
      id: 0,
      username: 'Not logged in',
      role: '',
      name: '',
      email: '',
      avatar: '',
      roleId: 0,
      orgId: 0,
      loginAccount: '',
      organization: '',
      organizationType: '',
      position: '',
      upward: false,
      // 新增欄位
      account: '',
      department: '',
      gender: '',
      birthday: ''
    },
    rolePermissions: [] as IFullPermission[],
    // 新增 preferences
    preferences: {
      language: '',
      timezone: ''
    }
  }),
  getters: {
    currentPagePermission(): { canAccess: boolean; canEdit: boolean } {
      // 使用更安全的型別檢查
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const routerName = (this as any).router?.currentRoute?.value?.name || '';

      const permission = this.rolePermissions.find(
        (item) => item.routerName === routerName
      );
      return {
        canAccess: permission ? permission.canAccess : false,
        canEdit: permission ? permission.canEdit : false
      };
    }
  },
  actions: {
    setLogin(state: boolean) {
      this.isLogin = state;
    },
    setUserInfo(state: IUserInfo) {
      this.userInfo = {
        id: state.id,
        username: state.username,
        name: state.name,
        role: state.role,
        roleId: state.roleId,
        orgId: state.orgId,
        email: state.email || '',
        avatar: state.avatar || '',
        loginAccount: state.loginAccount,
        organization: state.organization,
        organizationType: state.organizationType,
        position: state.position,
        upward: state.upward,
        // 新增欄位
        account: (state as any).account || '',
        department: (state as any).department || '',
        gender: (state as any).gender || '',
        birthday: (state as any).birthday || ''
      };
    },
    setPermissions(state: IFullPermission[]) {
      this.rolePermissions = state;
    },
    // 新增 setPreferences
    setPreferences(prefs: any) {
      this.preferences = prefs;
    }
  }
});
